import http from "@/libs/axios";

export function getRegions(params) {
  return http.get("knowledge_base/regions/", { params });
}

export function getStageTypes() {
  return http({
    method: "GET",
    url: "/knowledge_base/stage-type/",
  });
}

export function getCurrencies() {
  return http({
    method: "GET",
    url: "knowledge_base/currency/",
  });
}

export function getApartmentMaterials() {
  return http({
    method: "GET",
    url: "knowledge_base/home-material/",
  });
}

export function getPremisesDecorations() {
  return http({
    method: "GET",
    url: "knowledge_base/premises-decoration/",
  });
}

export function getConstructionStages() {
  return http({
    method: "GET",
    url: "knowledge_base/construction-stage/",
  });
}

export function getPlanningTypes() {
  return http({
    method: "GET",
    url: "knowledge_base/planning-type/",
  });
}

export function getOutputWindows() {
  return http({
    method: "GET",
    url: "knowledge_base/output-windows/",
  });
}

export function getMonths(params) {
  return http({
    method: "GET",
    url: "knowledge_base/month/",
    params,
  });
}

export function getQuarters() {
  return http({
    method: "GET",
    url: "knowledge_base/quarter/",
  });
}

export function getContentTypes(params) {
  return http({
    method: "GET",
    url: "knowledge_base/content-type/",
    params,
  });
}

export function getApartmentTypes() {
  return http({
    method: "GET",
    url: "knowledge_base/apartment-type/",
  });
}

export function getConstructionTypes() {
  return http({
    method: "GET",
    url: "knowledge_base/construction-type/",
  });
}

export function getFlatStatuses() {
  return http({
    method: "GET",
    url: "knowledge_base/flat-status/",
  });
}

export function getFlatDecorations() {
  return http({
    method: "GET",
    url: "/knowledge_base/decoration/",
  });
}

export function getFlatAreaTypes(params) {
  return http({
    method: "GET",
    url: "knowledge_base/room-title/",
    params,
  });
}

export function getOccupiedByList() {
  return http({
    method: "GET",
    url: "/knowledge_base/occupied-by/",
  });
}

export function getSaleOffices(params) {
  return http({
    method: "GET",
    url: "/knowledge_base/sale-office/",
    params,
  });
}

export function createSaleOffice(data) {
  return http({
    method: "POST",
    url: "/knowledge_base/sale-office/",
    data,
  });
}

export function updateSaleOffice(data) {
  return http({
    method: "PATCH",
    url: `/knowledge_base/sale-office/${data.get("id")}/`,
    data,
  });
}

export function deleteSaleOffice(id) {
  return http({
    method: "DELETE",
    url: `/knowledge_base/sale-office/${id}/`,
  });
}

export function getConstructors(params) {
  return http({
    method: "GET",
    url: "/knowledge_base/brand/",
    params,
  });
}

export function createConstructor(data) {
  return http({
    method: "POST",
    url: "/knowledge_base/brand/",
    data,
  });
}

export function updateConstructor(data) {
  return http({
    method: "PATCH",
    url: `/knowledge_base/brand/${data.id}/`,
    data,
  });
}

export function deleteConstructor(id) {
  return http({
    method: "DELETE",
    url: `/knowledge_base/brand/${id}/`,
  });
}

export function getPaymentInterests(params) {
  return http({
    method: "GET",
    url: "knowledge_base/payment-in-percent/",
    params,
  });
}

export function getPaymentMethods() {
  return http({
    method: "GET",
    url: "/knowledge_base/payment-method/",
  });
}

export function getOneConstructor(id) {
  return http({
    method: "GET",
    url: `/knowledge_base/brand/${id}/`,
  });
}

export function getProjectStaff(params) {
  return http({
    method: "GET",
    url: "knowledge_base/built-by/",
    params,
  });
}

export function createProjectStaff(data) {
  return http({
    method: "POST",
    url: "knowledge_base/built-by/",
    data,
  });
}

export function updateProjectStaff(data) {
  return http({
    method: "PATCH",
    url: `knowledge_base/built-by/${data.id || data.get("id")}/`,
    data,
  });
}

export function deleteProjectStaff(id) {
  return http({
    method: "DELETE",
    url: `knowledge_base/built-by/${id}`,
  });
}

export function deletePaymentInterest(id) {
  return http({
    method: "DELETE",
    url: `/knowledge_base/payment-in-percent/${id}`,
  });
}

export function createPaymentInterest(data) {
  return http({
    method: "POST",
    url: `/knowledge_base/payment-in-percent/`,
    data,
  });
}

export function deletePaymentOption(id) {
  return http({
    method: "DELETE",
    url: `/objects/discount-percent/${id}/`,
  });
}
